import { useEffect, useState } from 'react';
import Chart from "react-apexcharts";
import { formatarDadosParaHeatMap } from '../../../util/utilitarios';

// import { transformaDadosParaGraficoHeatMap, preencherDadosFaltantesParaGraficos } from '../../../util/utilitarios';

function HeatMapAlcanceUnidades({ dadosGraf }) {

    console.log('### Iniciando HeatMapAlcanceUnidades ###');
    
    dadosGraf = formatarDadosParaHeatMap(dadosGraf)

    dadosGraf = dadosGraf.reverse().map(item => ({
        ...item,
        data: item.data.reverse()
    }))

    const options = {
        plotOptions: {
            noData: { text: 'Não há dados para os filtros selecionados' },
            heatmap: {
                enableShades: false,
                colorScale: {

                    ranges: [
                        { // vermelho
                            from: 0,
                            to: 49.90,
                            name: '< 50%',
                            color: '#FF0000'
                        },
                        { // laranja
                            from: 50,
                            to: 59.95,
                            name: '50% - 59%',
                            color: '#FFB200'
                        },
                        { // amarelo
                            from: 60,
                            to: 69.9,
                            name: '60% - 69%',
                            color: '#e6e600'
                        },
                        { // verde mais claro
                            from: 70,
                            to: 79.9,
                            name: '70% - 79%',
                            color: '#00cc00'
                        },
                        { // verde
                            from: 80,
                            to: 89.9,
                            name: '80% - 89%',
                            color: '#00A100'
                        },
                        { // azul
                            from: 90,
                            to: 100,
                            name: '90% - 100%',
                            color: '#128FD9'
                        }
                    ],
                    inverse: true
                }
            }
        }
    }

    return (
        <div className='h-100 div-com-borda'>
            <Chart
                options={options}
                series={dadosGraf}
                type="heatmap"
                height="100%"
            />
        </div>
    );

}

export default HeatMapAlcanceUnidades
